module.exports = __webpack_public_path__ + "static/img/designnew.7f3683da.png";